import React from 'react';
import {useSelector} from "react-redux";

const PlanSummary = ({ planText, price, startDate, endDate }) => {

    const { kipMateCode, userType } = useSelector((state) => state.auth)

    return (
        <>
            <div className={`text-2xl lg:hidden`}><p>Sign Up</p></div>
            <div className="text-sm lg:text-base mt-2 lg:mt-4"><p>Your Plan</p></div>
            {userType === "corporate" && (
                <>
                    <div className="text-2xl mb-2"><p>12 Month Subscription</p></div>
                </>
            )}

            {userType === "individual" && (
                <>
                    <div className="text-2xl mb-2"><p>{planText} | {price}</p></div>
                </>
            )}


            <div className="text-base mt-1"><p>Membership Duration</p></div>
            <div className="text-xl flex flex-row gap-2 mb-2 ">
                <i className="text-pink-icon ri-calendar-line"></i>
                <p>{startDate} - {endDate}</p>
            </div>

            {userType === "corporate" && (
                <>
                    <div className="text-sm lg:text-base mt-1"><p>Your kipmate code:</p></div>
                    <div className="text-2xl mb-4 text-pink-icon"><p>{kipMateCode}</p></div>
                </>
            )}
        </>
    );
};

export default PlanSummary;